/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Secondary_Goal_HypertrophyInputs */

const en_us2_onboarding_secondary_goal_hypertrophy = /** @type {(inputs: Onboarding_Secondary_Goal_HypertrophyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build muscle`)
};

const pt_br2_onboarding_secondary_goal_hypertrophy = /** @type {(inputs: Onboarding_Secondary_Goal_HypertrophyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganhar músculo`)
};

const es_419_onboarding_secondary_goal_hypertrophy = /** @type {(inputs: Onboarding_Secondary_Goal_HypertrophyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganar músculo`)
};

const pt_pt2_onboarding_secondary_goal_hypertrophy = /** @type {(inputs: Onboarding_Secondary_Goal_HypertrophyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganhar músculo`)
};

const fr_fr2_onboarding_secondary_goal_hypertrophy = /** @type {(inputs: Onboarding_Secondary_Goal_HypertrophyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prendre du muscle`)
};

const de_de2_onboarding_secondary_goal_hypertrophy = /** @type {(inputs: Onboarding_Secondary_Goal_HypertrophyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muskeln aufbauen`)
};

const it_it2_onboarding_secondary_goal_hypertrophy = /** @type {(inputs: Onboarding_Secondary_Goal_HypertrophyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumentare la massa muscolare`)
};

/**
* | output |
* | --- |
* | "Build muscle" |
*
* @param {Onboarding_Secondary_Goal_HypertrophyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_secondary_goal_hypertrophy = /** @type {((inputs?: Onboarding_Secondary_Goal_HypertrophyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Secondary_Goal_HypertrophyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_secondary_goal_hypertrophy(inputs)
	if (locale === "es-419") return es_419_onboarding_secondary_goal_hypertrophy(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_secondary_goal_hypertrophy(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_secondary_goal_hypertrophy(inputs)
	if (locale === "de-DE") return de_de2_onboarding_secondary_goal_hypertrophy(inputs)
	if (locale === "it-IT") return it_it2_onboarding_secondary_goal_hypertrophy(inputs)
	return en_us2_onboarding_secondary_goal_hypertrophy(inputs)
});
export { onboarding_secondary_goal_hypertrophy as "onboarding.secondary_goal.hypertrophy" }